import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";
import dataService from "../../api";


export default {
    namespaced: true,
    state: {
        reasons: [],
        reason: {
            name: 'احمد', 
            createdBy: null,
            createdOn: null,
            status: 1,
        },
        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.reasons.findIndex(i => i.id === id)
    },
    mutations: {
        SET_REASONS: (state, data) => state.reasons = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_REASON: (state, viewData) => state.patient = viewData,
        ADD: (state, addedData) => state.reasons.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.reasons.splice(index, 1, updateData),
        DELETE: (state, index) => state.reasons.splice(index, 1),
    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                    const response = await dataService.reasons.getAll(paramsString);
                    stopLoading()
                    if (!response.data.statusCode) {
                        showAlert(serverErrorMessage);
                        return;
                    }
        
                commit('SET_REASONS', response.data.reasons);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async get({ commit }, id) {
            startLoading()
            try {
                commit('SET_REASON', {});
                const response = await dataService.reasons.getDetails(id);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
    
                commit('SET_REASON', response.data);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getforEdit(_, id) {
            startLoading();
            try {
                
                const response = await dataService.reasons.getForEdit(id);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
    
                return Promise.resolve(response.data);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },

        async add({ commit }, payload) {
            startLoading()
            try {
                const response = await dataService.reasons.add(payload);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

               commit('ADD', response.data.reason);
            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async update({ commit, getters }, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.reasons.edit(id, payload);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('UPDATE', { index: index, updateData: response.data.reason });

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async delete({ commit, getters }, id) {
            startLoading()
            try {
                const response = await dataService.reasons.delete(id);
                stopLoading();
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);
                commit('DELETE', index);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
    },
};
